import { FONT_FAMILY, THEME_COLORS } from "@common/themes";
import MaterialIcons from "@expo/vector-icons/MaterialIcons";
import React from "react";
import {
  Clipboard,
  StyleSheet,
  Text,
  TextProps,
  TextStyle,
  TouchableOpacity,
  View,
} from "react-native";
import TooltipV3 from "../TooltipV3";
import styles from "./styles";

export interface AppTextPropTypes extends TextProps {
  fontFamily?:
    | "regular"
    | "medium"
    | "semibold"
    | "bold"
    | "thin"
    | "futura-medium";
  fontSize?: number;
  color?: string;
  addToolTip?: boolean;
  allowTextCopy?: boolean;
  textAlign?: TextStyle["textAlign"];
}

const fontMapping = {
  bold: FONT_FAMILY.boldV3,
  medium: FONT_FAMILY.mediumV3,
  regular: FONT_FAMILY.primaryV3,
  semibold: FONT_FAMILY.semiBoldV3,
  thin: FONT_FAMILY.thinV3,
  "futura-medium": FONT_FAMILY.two,
};

const AppText = ({
  fontFamily = "regular",
  fontSize = 14,
  color = THEME_COLORS.black,
  style,
  children,
  numberOfLines,
  addToolTip,
  allowTextCopy,
  textAlign,
  ...props
}: AppTextPropTypes) => {
  const onCopyText = () => {
    if (typeof children === "string" || typeof children === "number") {
      Clipboard.setString(children + "");
    } else {
      console.warn("AppText: children is not string type.");
    }
  };

  const textNode = (
    <Text
      style={[
        styles.text,
        {
          color,
          fontSize,
          textAlign,
          fontFamily: fontMapping[fontFamily],
        },
        style,
      ]}
      numberOfLines={numberOfLines}
      selectable
      {...props}
    >
      {children}
      {allowTextCopy ? (
        <TouchableOpacity style={styles.copyTO} onPress={onCopyText}>
          <MaterialIcons
            name="content-copy"
            size={fontSize * 1.2}
            color={THEME_COLORS.purple}
          />
        </TouchableOpacity>
      ) : null}
    </Text>
  );

  return (
    <>
      {addToolTip ? (
        <TooltipV3
          style={{ maxWidth: "100%" }}
          title={children}
          placement="top"
          arrow={false}
        >
          {textNode}
        </TooltipV3>
      ) : (
        textNode
      )}
    </>
  );
};

export default AppText;
